  tarteaucitron.init({
    "privacyUrl": "", /* Privacy policy url */

    "hashtag": "#tarteaucitron", /* Open the panel with this hashtag */
    "cookieName": "tarteaucitron", /* Cookie name */

    "orientation": "bottom", /* Banner position (top - bottom) */
                     
    "showAlertSmall": false, /* Show the small banner on bottom right */
    "cookieslist": false, /* Show the cookie list */
                     
    "showIcon": true, /* Show cookie icon to manage cookies */
    "iconPosition": "BottomLeft", /* BottomRight, BottomLeft, TopRight and TopLeft */

    "adblocker": false, /* Show a Warning if an adblocker is detected */
                     
    "DenyAllCta" : false, /* Show the deny all button */
    "AcceptAllCta" : true, /* Show the accept all button when highPrivacy on */
    "highPrivacy": false, /* HIGHLY RECOMMANDED Disable auto consent */
                     
    "handleBrowserDNTRequest": false, /* If Do Not Track == 1, disallow all */

    "removeCredit": true, /* Remove credit link */
    "moreInfoLink": false, /* Show more info link */

    "useExternalCss": true, /* If false, the tarteaucitron.css file will be loaded */
    "useExternalJs": false, /* If false, the tarteaucitron.js file will be loaded */

    "cookieDomain": "leplandelatour.fr", /* Shared cookie for multisite */
                    
    "readmoreLink": "", /* Change the default readmore link */

    "mandatory": true, /* Show a message about mandatory cookies */
  });

/*jshint expr:true */

// function toggle(elemID) {
// 	var elem = document.getElementById(elemID);
// 	if (elem.style.display == 'block') {
// 		elem.style.display = 'none';
// 	} else {
// 		elem.style.display = 'block';
// 	}
// }

/*
 * Foundation
 */
$(document).foundation();

/*
 * Laravel csrf token
 * http://stackoverflow.com/questions/21627170/laravel-tokenmismatchexception-in-ajax-request
 */
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});


/*
 * lightbox
 */
$("[data-fancybox]").fancybox({
    // Options will go here
});


/*
 * Tabs personnalisées
 */
$('.tabs-cs').each(function() {
    var current = null;
    current = $(this).find('a:first').attr('href');
    $(this).find('a[href="' + current + '"]').addClass('active');
    $(current).siblings().hide();
    $(this).find('a').click(function(e) {
        e.preventDefault();
        var link = $(this).attr('href');
        if (link == current) {
            return false;
        } else {
            $(this).siblings().removeClass('active');
            $(this).addClass('active');
            $(link).show().siblings().hide();
            current = link;
        }
    });
});


/*
 * scrollReveal
 * https://github.com/julianlloyd/scrollReveal.js
 */
var srConfig = {
    wait: '1s'
};
window.sr = scrollReveal(srConfig);


/*
 * Lazy load
 * http://www.appelsiini.net/projects/lazyload
 */
$(document).ready(function() {
    $(".lazy").lazyload({
        effect: "fadeIn",
        threshold: 600
    });
});

$('.flex-item label').click(function() {
    $(this).toggleClass('alert-success');
});


/*
 ** Style the first word
 */
$(document).ready(function() {
    $('.first-word').each(function() {
        var word = $(this).html();
        var index = word.indexOf(' ');
        if (index == -1) {
            index = word.length;
        }
        $(this).html('<span class="first-word">' + word.substring(0, index) + '</span>' + word.substring(index, word.length));
    });
});

/*
 ** HeroSlider
 */
(function($) {

    //sliders
    $('#HeroSlider').bxSlider({
        mode: 'fade',
        pause: 6000,
        slideWidth: 1000,
        minSlides: 1,
        maxSlides: 1,
        moveSlides: 1,
        slideMargin: 0,
        pager: true,
        //pagerCustom: '#bx-pager',
        auto: true,
        captions: true,
        controls: false
    });

})(jQuery);

/*
 * HeroSlider fixed
 */

$(window).scroll(function() {
    var posScroll = $(document).scrollTop();
    if (posScroll >= 1000) {
        $('.SiteHeader .bx-wrapper').css({ position: 'absolute' });
    } else {
        $('.SiteHeader .bx-wrapper').css({ position: 'fixed' });
    }
});

/*
 ** Slideshow Retro
 */
$('.bxslider').bxSlider({
    auto: true,
    pager: false
        // pagerCustom: '.SliderRetro1-pager',
        // mode: 'fade'
        // captions: true,
        // nextSelector: '#slider-next1',
        // prevSelector: '#slider-prev1',
        // nextText: '<i class"fal fa-chevron-right" aria-hidden="true"></i>',
        // prevText: '<i class"fal fa-chevron-left" aria-hidden="true"></i>'
});



/*
 ** Form Contact
 */
(function($) {
    $("#form_contact").submit(function(e) {
        e.preventDefault();
        $('label.is-invalid-label').removeClass('is-invalid-label');
        $('#form_contact input, #form_contact textarea').removeClass('is-invalid-input');
        $('span.form-error').remove();

        var url = $(this).attr('action');
        var data = $(this).serialize();
        $.ajax({
            type: 'POST',
            url: url,
            data: data,
            dataType: 'json'
        }).done(function(data) {
            $('#form_contact').slideUp();
            $('.required').remove();
            $('#contact').prepend('<div class="callout success">Merci ' + data.nom + ', nous avons bien enregistré votre message.</div>' +
                '<ul>' +
                '<li>Nom : ' + data.nom + '</li>' +
                '<li>Email : ' + data.email + '</li>' +
                '<li>Message : ' + data.message + '</li></ul></div>');
        }).fail(function(data) {
            $.each(data.responseJSON, function(key, value) {
                var input = '#form_contact #' + key;
                $(input).after('<span class="form-error is-visible" data-form-error-for="' + key + '">' + value + '</span>');
                $(input).addClass('is-invalid-input');
                $(input).parent().addClass('is-invalid-label');
            })
        });

    });
})(jQuery);


/*
 ** Form Newsletter
 */
(function($) {
    $(".form_email").submit(function(e) {
        e.preventDefault();

        var url = $(this).attr('action');
        var data = $(this).serialize();
        $.ajax({
            type: 'POST',
            url: url,
            data: data,
            dataType: 'json'
        }).done(function(msg) {
            swal({
                    title: "Merci de votre intérêt",
                    text: "Souhaitez-vous recevoir la newsletter en cours ?",
                    type: "success",
                    allowOutsideClick: false,
                    showCancelButton: true,
                    cancelButtonText: 'Non merci !',
                    confirmButtonColor: '#008CBA',
                    confirmButtonText: 'Oui',
                    closeOnConfirm: false
                },
                function() {
                    swal("Félicitations !", "La newsletter en cours vous a été envoyé", "success");
                });

        }).error(function(msg) {
            swal("Oops...", msg.errors, "error");
        });


    });
})(jQuery);


/*
 ** Button alert
 */
(function($) {
    $(".form_delete").submit(function(e) {
        e.preventDefault();

        var url = $(this).attr('action');
        var data = $(this).serialize();
        var parent = $(this).parents('tr');
        swal({
                title: "Êtes-vous sûr ?",
                text: "",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'Yes, we did it !',
                closeOnConfirm: false
            },
            function() {
                $.ajax({
                    type: 'POST',
                    url: url,
                    data: data,
                    dataType: 'json'
                }).done(function(msg) {
                    swal("Félicitations !", msg.ok, "success");
                    parent.addClass('hidden');
                }).error(function(msg) {
                    swal("Oops...", msg.errors, "error");
                });
            });
    });
})(jQuery);


/*
 ** Helpers Class
 */
$(document).ready(function() {

    $(".clickBox, .clickBox > *").click(function() {
        window.location = $(this).find("a").attr("href");
        return false;
    });

});


/*
 ** Calendar
 */
$(document).ready(function() {

    $('#CalendarEvents').fullCalendar({
        height: "auto",
        header: {
            left: 'prev',
            center: 'title',
            right: 'next'
        },

        columnFormat: {
            month: 'ddd',
            week: 'ddd M/d',
            day: 'dddd M/d'
        },

        firstDay: 1,
        monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
        monthNamesShort: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sept', 'Oct', 'Nov', 'Déc'],
        dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
        dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],

        eventLimit: false, // allow "more" link when too many events
        eventSources: [{
            url: base_url + lang_url + '/prestas/getJsonEvents?lang=' + lang_url,
            color: '#fbb03b',
            textColor: 'black'
        }],

        color: 'yellow',
        textColor: 'black',

        eventClick: function(calEvent, jsEvent, view) {
            var $modal = $('#calendarModal').html(calEvent.content);
            var calendarModal = new Foundation.Reveal($modal);
            calendarModal.open();

            // change the border color just for fun
            $(this).css('border-color', 'black');

        },

        loading: function(bool) {
            if (bool) {
                $('#loading').show();
            } else {
                $('#loading').hide();
            }
        }
    });

});


/*
 **  Map
 */
$(document).ready(function() {
    $('#zone-1').click(function() { $('#lightbox-zone-1').show('slow'); });
    $('.lightbox').click(function() {
        $(this).hide('slow');
    });
});


/*
 * ScrollToTop
 */
$(window).scroll(function() {
    var posScroll = $(document).scrollTop();
    var scrollToTop = $('.scrollToTop');
    if (posScroll >= 186) {
        scrollToTop.addClass('show');
    } else {
        scrollToTop.removeClass('show');
    }
});


/*
 * Social stream home page
 */
$(document).ready(function() {
    if ($('#WelcomeStream').length) {
        $('#WelcomeStream').dcSocialStream({
            feeds: {
                // rss: {
                //     id: base_url + '/fr/blog/feed',
                //     out: 'intro,thumb,title,text,share',
                //     url: base_url + '/rss.php'
                // },
                facebook: {
                    id: '104859405732411',
                    image_width: 2,
                    url: base_url + '/facebook.php',
                    feed: 'posts' // feed, posts
                        //text: 'contentSnippet',
                },
            },
            rotate: {
                delay: 0
            },
            control: false,
            filter: false,
            height: 'auto',
            wall: false,
            cache: true,
            max: 'limit',
            days: 30,
            limit: 7,
            iconPath: theme_url + '/images/social-stream/dcsns-dark/',
            imagePath: theme_url + '/images/social-stream/dcsns-dark/'
        });


    }
});

$('.SliderActus').bxSlider({
    slideWidth: 333,
    slideMargin: 15,
    minSlides: 1,
    maxSlides: 3,
    nextSelector: '#SliderActus-next',
    prevSelector: '#SliderActus-prev',
    nextText: '<i class="fal fa-2x fa-angle-right"></i>',
    prevText: '<i class="fal fa-2x fa-angle-left"></i>',
    pager: false,
    auto: true
});